import { ConvertCropNameToKey } from "./Helpers";
import getListOfIssues from "./getListOfIssues";

export function getBothIssues(surveyData, cropName) {
    const key = surveyData.pests ? ConvertCropNameToKey(surveyData.pests, cropName) : surveyData.diseases ? ConvertCropNameToKey(surveyData.diseases, cropName) : null;
    const listOfPests = (surveyData.pests !== null) ? getListOfIssues(surveyData.pests[key], true) : [];
    const listOfDiseases = (surveyData.diseases !== null) ? getListOfIssues(surveyData.diseases[key], true) : [];
    return { listOfPests, listOfDiseases };
}
